import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ApiKeyLayer from "./ApiKeyLayer";

const ApiKeyPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="API Key Generate" />
      <ApiKeyLayer />
    </MasterLayout>
  );
};

export default ApiKeyPage;
